module.exports = __webpack_public_path__ + "static/media/locallodging.c7f93281.png";